// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"3cce324c","453":"690e9079"}[chunkId] + ".chunk.js";
};